import { Injectable } from '@angular/core';
import { Translation } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { selectBffBaseUrl } from '../../store/selectors/api-config.selectors';
import { APIService, HttpParamsObject } from './api.service';
import { ConsentUrls } from '@core/data/consent-urls/models/consent-urls.model';

@Injectable({ providedIn: 'root' })
export class ContentApiService {
  private baseAppContentPath$: Observable<string>;

  public translationsUrl$: Observable<string>;

  constructor(
    private apiService: APIService,
    private store: Store,
  ) {
    this.baseAppContentPath$ = this.store.pipe(
      selectBffBaseUrl,
      map((url) => `${url}/app/content`) /** @todo move to app-config */,
      take(1),
    );
    this.translationsUrl$ = this.baseAppContentPath$.pipe(
      map((baseAppContentPath) => `${baseAppContentPath}/ui_labels`),
      take(1),
    );
  }

  public getPool(paramsObject?: HttpParamsObject): Observable<fhir4.Bundle> {
    return this.baseAppContentPath$.pipe(
      switchMap((baseAppContentPath) =>
        this.apiService.callGetAPI<fhir4.Bundle>(
          `${baseAppContentPath}/pool`,
          paramsObject,
        ),
      ),
    );
  }

  public getTranslation(language: string): Observable<Translation> {
    const headers = { 'Accept-Language': language.split('-')[0] };
    return this.translationsUrl$.pipe(
      switchMap((translationsUrl) =>
        this.apiService.callGetAPI(translationsUrl, {}, headers),
      ),
    );
  }

  public getConsentUrls(language: string): Observable<ConsentUrls> {
    return this.baseAppContentPath$.pipe(
      switchMap((baseAppContentPath) =>
        this.apiService.callGetAPI<ConsentUrls>(
          `${baseAppContentPath}/consent_urls?language=` +
            language.split('-')[0],
        ),
      ),
    );
  }
}
